import {WicketUser} from '@tisa-group/models';

export class LoadLegalDocument {
  static readonly type = '[LegalDocuments] Load Legal Document';

  constructor(
    readonly language: WicketUser['preferred_language'],
    readonly documentType: string,
    readonly applicationId: string,
  ) {}
}
